import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { initSentry } from "./lib/sentry";
import "./lib/i18n";
import "./styles/index.css";
import "./index.css";
import { router } from "./routes";
import { AuthProvider } from "./contexts/AuthContext";
import { FullscreenProvider } from "./contexts/FullscreenContext";
import { KeyboardShortcutsProvider } from "./contexts/KeyboardShortcutsContext";
import { OrgProvider } from "./contexts/OrgContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { ThemeProvider } from "./contexts/ThemeContext";

initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <SettingsProvider>
        <FullscreenProvider>
          <AuthProvider>
            <OrgProvider>
              <KeyboardShortcutsProvider>
                <RouterProvider router={router} />
              </KeyboardShortcutsProvider>
            </OrgProvider>
          </AuthProvider>
        </FullscreenProvider>
      </SettingsProvider>
    </ThemeProvider>
  </StrictMode>,
);
